


.responsive3208187990__root .Button3137695127__root {
    background-color: var(--Buttonresponsive3436484754-color-background);
    --Buttonresponsive3436484754-color-hover-background: var(--Buttonresponsive3436484754-color-background);
    --Buttonresponsive3436484754-color-active-background: var(--Buttonresponsive3436484754-color-background);
    --Buttonresponsive3436484754-color-hover-text: var(--Buttonresponsive3436484754-color-text);
    --Buttonresponsive3436484754-color-active-text: var(--Buttonresponsive3436484754-color-text);
}

.responsive3208187990__root .Button3137695127__root .Button3137695127__text.Text899316905---skin-8-standard {
  color: var(--Buttonresponsive3436484754-color-text);
}

  /* Hover */
.responsive3208187990__root .Button3137695127__root:hover {
    background-color: var(--Buttonresponsive3436484754-color-hover-background);
}

.responsive3208187990__root .Button3137695127__root:hover .Button3137695127__text.Text899316905---skin-8-standard {
    color: var(--Buttonresponsive3436484754-color-hover-text);
}

/* Active */
.responsive3208187990__root .Button3137695127__root:active {
    background-color: var(--Buttonresponsive3436484754-color-active-background);
}

.responsive3208187990__root .Button3137695127__root:active .Button3137695127__text.Text899316905---skin-8-standard {
    color: var(--Buttonresponsive3436484754-color-active-text);
}

/* Focus */
.responsive3208187990__root .Button3137695127__root:focus-visible:not(:active) {
    box-shadow: 0 0 0 2px #7cafff;
}

/* Disabled */
.responsive3208187990__root .Button3137695127__root.Button3137695127--disabled {
    cursor: initial;
    background-color: var(--Buttonresponsive3436484754-color-disabled-background);
}

.responsive3208187990__root .Button3137695127__root.Button3137695127--disabled .Button3137695127__text.Text899316905---skin-8-standard {
    color: var(--Buttonresponsive3436484754-color-disabled-text);
}

  /* Skin */
.responsive3208187990__root .Button3137695127__root.Button3137695127---skin-8-standard {
    --Buttonresponsive3436484754-color-background: #116dff;
    --Buttonresponsive3436484754-color-text: #ffffff;
    --Buttonresponsive3436484754-color-hover-background: #0f62e6;
    --Buttonresponsive3436484754-color-disabled-background: #f3f3f3;
    --Buttonresponsive3436484754-color-disabled-text: #bebebe;
}

.responsive3208187990__root .Button3137695127__root.Button3137695127---skin-9-secondary {
    --Buttonresponsive3436484754-color-background: #ffffff;
    box-shadow: inset 0 0 0 1px #cfd1dc;
    --Buttonresponsive3436484754-color-text: #116dff;
    --Buttonresponsive3436484754-color-hover-background: #f4f5f8;
    --Buttonresponsive3436484754-color-disabled-background: #ffffff;
    --Buttonresponsive3436484754-color-disabled-text: #bebebe;
}

.responsive3208187990__root .Button3137695127__root.Button3137695127---skin-8-inverted {
    --Buttonresponsive3436484754-color-background: transparent;
    --Buttonresponsive3436484754-color-text: #116dff;
    box-shadow: inset 0 0 0 1px #116dff;
    --Buttonresponsive3436484754-color-hover-background: #116dff;
    --Buttonresponsive3436484754-color-disabled-background: #f3f3f3;
    --Buttonresponsive3436484754-color-disabled-text: #bebebe;
    --Buttonresponsive3436484754-color-active-text: #116dff;
    --Buttonresponsive3436484754-color-hover-text: #ffffff;
}

.responsive3208187990__root .Button3137695127__root.Button3137695127---skin-8-inverted:focus-visible {
    box-shadow: 0 0 0 2px #7cafff, inset 0 0 0 1px #116dff;
}

.responsive3208187990__root .Button3137695127__root.Button3137695127---skin-8-inverted.Button3137695127--disabled {
    box-shadow: none;
}

.responsive3208187990__root .Button3137695127__root.Button3137695127---skin-5-light {
    --Buttonresponsive3436484754-color-background: #ffffff;
    --Buttonresponsive3436484754-color-text: #116dff;
    --Buttonresponsive3436484754-color-hover-background: #f4f5f8;
    --Buttonresponsive3436484754-color-disabled-background: #ffffff;
    --Buttonresponsive3436484754-color-disabled-text: #bebebe;
}

.responsive3208187990__root .Button3137695127__root.Button3137695127---skin-4-dark {
    --Buttonresponsive3436484754-color-background: rgba(23, 25, 28, 0.7); /* TODO - not in palette */
    --Buttonresponsive3436484754-color-text: #ffffff;
    box-shadow: inset 0 0 0 2px rgba(255, 255, 255, 0.7); /* TODO - not in palette */
    --Buttonresponsive3436484754-color-hover-text: #116dff;
    --Buttonresponsive3436484754-color-disabled-background: rgba(122, 122, 122, 0.7); /* TODO - not in palette */
    --Buttonresponsive3436484754-color-disabled-text: #ffffff;
}

.responsive3208187990__root .Button3137695127__root.Button3137695127---skin-4-dark:hover {
    box-shadow: inset 0 0 0 2px rgba(17, 109, 255, 0.7); /* TODO - not in palette */
}

.responsive3208187990__root .Button3137695127__root.Button3137695127---skin-4-dark.Button3137695127--disabled {
    box-shadow: inset 0 0 0 2px rgba(255, 255, 255, 0.7); /* TODO - not in palette */
}

.responsive3208187990__root .Button3137695127__root.Button3137695127---skin-4-dark:focus-visible {
    box-shadow: 0 0 0 2px #7cafff, inset 0 0 0 2px rgba(255, 255, 255, 0.7); /* TODO - not in palette */
}

.responsive3208187990__root .Button3137695127__root.Button3137695127---skin-7-premium {
    --Buttonresponsive3436484754-color-background: #5a48f5;
    --Buttonresponsive3436484754-color-text: #ffffff;
    --Buttonresponsive3436484754-color-hover-background: #4D3DD0;
    --Buttonresponsive3436484754-color-disabled-background: #f3f3f3;
    --Buttonresponsive3436484754-color-disabled-text: #bebebe;
}

.responsive3208187990__root .Button3137695127__root.Button3137695127---skin-17-premium-secondary {
    --Buttonresponsive3436484754-color-background: #ffffff;
    --Buttonresponsive3436484754-color-text: #5a48f5;
    box-shadow: inset 0 0 0 1px #cfd1dc;
    --Buttonresponsive3436484754-color-hover-background: #f4f5f8;
    --Buttonresponsive3436484754-color-disabled-background: #ffffff;
    --Buttonresponsive3436484754-color-disabled-text: #bebebe;
}

.responsive3208187990__root .Button3137695127__root.Button3137695127---skin-17-premium-secondary.Button3137695127--disabled {
    box-shadow: none;
}

  .responsive3208187990__root .Button3137695127__root.Button3137695127---skin-5-alert {
    --Buttonresponsive3436484754-color-background: #ee4437;
    --Buttonresponsive3436484754-color-text: #ffffff;
    --Buttonresponsive3436484754-color-hover-background: #ca3a2f;
    --Buttonresponsive3436484754-color-disabled-background: #f3f3f3;
    --Buttonresponsive3436484754-color-disabled-text: #bebebe;
  }

  .responsive3208187990__root .Button3137695127__root.Button3137695127---skin-15-alert-secondary {
    --Buttonresponsive3436484754-color-background: #ffffff;
    --Buttonresponsive3436484754-color-text: #000624;
    --Buttonresponsive3436484754-color-hover-background: #f4f5f8;
    --Buttonresponsive3436484754-color-disabled-background: #ffffff;
    --Buttonresponsive3436484754-color-disabled-text: #bebebe;
}



  .responsive3208187990__root .Button3137695127__root.Button3137695127---size-5-small {
    padding: 4px 12px;
    border-radius: 4px;
  }

  .responsive3208187990__root .Button3137695127__root.Button3137695127---size-6-medium {
    padding: 6px 16px;
    height: 32px;
    border-radius: 4px;
  }

  .responsive3208187990__root .Button3137695127__root.Button3137695127---size-5-large {
    padding: 8px 16px;
    height: 36px;
    border-radius: 4px;
  }

/* Suffix */
.responsive3208187990__root .Button3137695127__root.Button3137695127---size-5-large.Button3137695127--suffix,
.responsive3208187990__root .Button3137695127__root.Button3137695127---size-6-medium.Button3137695127--suffix {
    padding-inline-end: 10px;
}

/* Prefix */
  .responsive3208187990__root .Button3137695127__root.Button3137695127---size-5-large.Button3137695127--prefix,
  .responsive3208187990__root .Button3137695127__root.Button3137695127---size-6-medium.Button3137695127--prefix {
      padding-inline-start: 10px;
  }



/* st-namespace-reference="../../../../src/atoms/Button/Button.responsive.st.css" */